<template>
  <div :class="['w3-row', 'definition-wrapper', 'html', definition.id, {'error_validate': mandatoryValidation}]">
    <div :class="['w3-col', 'tiny', {'languageHtml': (isMultiLanguage() && showMultilanguage) || (definition.task && definition.task.length > 0 && editable)}, {'translation': isForCopy()}]">
      <div class="tinymcetmd">
        <iframe v-if="readOnly" class="htmlReadOnly" scrolling="no"
          :ref="tinyId"
        />
        <transition-group name="fade" mode="out-in">
          <div v-show="editing" class="editing" key="editingZone">
            <transition name="fade" mode="out-in">
              <div>
                <grapes-js-editor
                  v-if="languageSelected && editorContent"
                  :content="editorContent"
                  :wsEndpoint="getTemplateValue('wsendpoint')"
                  :wsFileuploadProcessor="getTemplateValue('wsfileuploadprocessor')"
                  :wsGetProcessor="getTemplateValue('wsgetprocessor')"
                  :save="saveTemplate"
                  :lang="getLang()"
                  :languageSelected="languageSelected"
                  :type="getTypeValue()"
                  :texts="editorTexts"
                  :variables="{
                    individual: this.getTemplateDomain('individualformvars'),
                    professional: this.getTemplateDomain('professionalformvars'),
                    indicator: this.getTemplateDomain('individualindicatorvars')
                  }"
                  :apiparams="apiparams"
                  @editorLoaded="definitionLoaded"
                  @editorChange="editorChange"
                  @editorSave="editorSave"
                />
                <div class="editor-buttons">
                  <button class="save" @click="saveEditor"><span>{{ getLang('save') }}</span></button>
                  <button class="cancel" @click="cancelEditor"><span>{{ getLang('cancel') }}</span></button>
                </div>
              </div>
            </transition>
          </div>
          <div v-show="!editing" class="preview" key="noEditingZone">
            <transition name="gallery-fade">
              <div class="overImage" v-if="!isHtmlUploaded() && editable">
                <div class="text">
                  <span class="edit" @click="previewToEdit">{{ getLang('edit') }}</span>
                </div>
              </div>
            </transition>
            <iframe class="htmlReadOnly" scrolling="yes"
              :ref="previewId"
            />
          </div>
        </transition-group>
      </div>
    </div>
    <div v-if="isMultiLanguage() && showMultilanguage" class="w3-rest tiny-rest" :class="['languageSelectorOrTask']">
      <div v-if="editorContent && isMultiLanguage() && showMultilanguage" :class="['languageSelectorHtml', 'languageSelector']">
        <definition-multilanguage
          :definition="definition" :object="object" :languageSelected="languageSelected" :translating="translating" :language="language" :apiparams="apiparams"
          @newLanguageSelected="newLanguageSelected" @copy="copy"
        />
      </div>
    </div>
    <div class="w3-rest tiny-rest remove">
      <div v-if="editorContent && editable">
        <i class="sherpa-icon icon-trash" @click="deleteHtml" v-tooltip="{content: getLang('deleteHtml'), delay: { show: 400, hide: 100 }, placement: 'auto'}"></i>
      </div>
    </div>
    <definition-task v-if="definition.task && definition.task.length > 0 && editable"
      class="w3-col" :definition="definition" :object="object" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :languageSelected="languageSelected" :language="language" :authorization="authorization" :type="type" :visuals="visuals" :apiparams="apiparams"
      @refreshDefinition="taskValueChanged" @refreshDefinitionContent="refreshDefinitionContent" @taskLink="taskLink"
    />
  </div>
</template>

<script>
import DefinitionReadOnly from './readOnly'
import DefinitionMultilanguage from './multilanguage'
import DefinitionTask from './task'
import transport from 'vue-definition-utils/src/utils/transport'
import moment from 'moment'
import language from '../language'

import GrapesJsEditor from 'vue-grapesjs-editor'

export default {
  name: 'definition-html',
  props: [
    'content',
    'definition',
    'object',
    'editable',
    'mandatoryValidation',
    'languageSelected',
    'tinyId',
    'definitionId',
    'definitionContentId',
    'repeatableGroupCode',
    'readOnly',
    'showMultilanguage',
    'requestObjectForAdd',
    'requestObjectForAddModified',
    'language',
    'authorization',
    'type',
    'visuals',
    'apiparams'
  ],
  components: {
    GrapesJsEditor,
    DefinitionReadOnly,
    DefinitionMultilanguage,
    DefinitionTask
  },
  data () {
    return {
      htmlValue: '',
      validation: null,
      initParam: null,
      txt: '',
      translating: false,
      previousLanguageKey: null,
      savingLanguageTemplate: false,
      editorTexts: {
        addIndividualParamsTitle: this.getLang('addIndividualParamsTitle'),
        addProfessionalParamsTitle: this.getLang('addProfessionalParamsTitle'),
        addIndicatorParamsTitle: this.getLang('addIndicatorParamsTitle'),
        selectText: this.getLang('select')
      },
      saveTemplate: null,
      editorContent: null,
      editorContentBckp: null,
      editing: false,
      previewId: 'preview',
      loadingEditor: false
    }
  },
  methods: {
    // 1.1. Launch validate mandatory event on change
    valueChanged (event) {
      this.setObjectHtmlValue()
      this.$emit('validateMandatory', moment().valueOf(), this.object)
    },
    taskValueChanged (object) {
      if (this.isMultiLanguage()) {
        this.htmlValue = transport.methods.getLanguageValue(object, this.languageSelected.key)
      } else {
        this.htmlValue = object.textValue
      }
      this.setObjectHtmlValue(object, true)
      this.$emit('validateMandatory', moment().valueOf(), this.object)
    },
    validateHtmlFormat () {
      var format = null
      if (this.isMultiLanguage()) {
        format = transport.methods.getLanguage(this.languageSelected.key, this.definition).format
      } else {
        format = this.definition.validation.format
      }

      this.validation = transport.methods.validateHtmlFormat(this.definition, format, this.htmlValue)
      // 3. if text format validation past...
      if (this.validation === null) {
        // ... launch refresh definition event
        this.$emit('refreshDefinition', this.object)
      } else {
        // ... or launch text format error event to show error message
        this.$emit('htmlFormatError', moment().valueOf(), this.validation)
      }
    },
    isMultiLanguage () {
      return transport.methods.isMultiLanguage(this.definition)
    },
    newLanguageSelected (language) {
      this.$emit('newLanguageSelected', language)
    },
    setObjectHtmlValue (object, fromUploadTask) {
      var metadataObj = null
      if (fromUploadTask) {
        metadataObj = this.getRequestObjectById(this.requestObjectForAdd, this.definition.id + 'metadata')
      }

      if (this.isMultiLanguage()) {
        if (object) {
          this.object.languageValue = object.languageValue

          if (metadataObj) {
            for (var i = 0; i < metadataObj.languageValue.length; i++) {
              metadataObj.languageValue[i].value = ''
            }
          }
        }
        this.object = transport.methods.setLanguageValue(this.object, this.htmlValue, this.languageSelected.key)
      } else {
        this.object.textValue = this.htmlValue
      }

      this.setIframeHtml('preview')
      if (this.readOnly) {
        this.setIframeHtml(this.tinyId)
      }
    },
    setHtmlValue (languageSelected) {
      if (!this.isMultiLanguage() && this.object.textValue) {
        this.htmlValue = this.object.textValue
        this.setIframeHtml('preview')
        if (this.readOnly) {
          this.setIframeHtml(this.tinyId)
        }
      } else if (languageSelected) {
        this.setLanguageHtmlValue(languageSelected)
        this.editorContent = this.getMetadataValue()
      }
    },
    setLanguageHtmlValue (languageSelected) {
      this.htmlValue = transport.methods.getLanguageValue(this.object, languageSelected.key)
      this.setIframeHtml('preview')
      if (this.readOnly) {
        this.setIframeHtml(this.tinyId)
      }
    },
    setIframeHtml (id) {
      var doc = this.$refs[id].contentWindow.document
      doc.open()
      doc.write(this.htmlValue)
      doc.close()
    },
    refreshDefinition (object) {
      this.htmlValue = transport.methods.getLanguageValue(object, this.languageSelected.key)
      this.$emit('refreshDefinition', object)
    },
    refreshObjectHtmlValue (requestObjectForAdd) {
      var object = transport.methods.getRequestObjectById(this.definition.id, [requestObjectForAdd])
      if (this.isMultiLanguage()) {
        this.htmlValue = transport.methods.getLanguageValue(object, this.languageSelected.key, [this.definition])
      } else {
        this.htmlValue = object.textValue
      }
      this.setObjectHtmlValue(object)
    },
    getMetadataLangValue (fromLanguage) {
      var result = null
      var metadataObj = this.getRequestObjectById(this.requestObjectForAdd, this.definition.id + 'metadata')
      for (var i = 0; i < metadataObj.languageValue.length && !result; i++) {
        if (metadataObj.languageValue[i].key === fromLanguage.key) {
          result = metadataObj.languageValue[i].value
        }
      }
      return result
    },
    copy (fromLanguage) {
      if (this.htmlValue.trim() !== '' && this.isMultiLanguage() && this.object.languageValue && this.object.languageValue.length > 1) {
        this.translating = true
        var self = this
        setTimeout(function () {
          self.copyLanguage(fromLanguage, 0, self.object.languageValue, self.getMetadataLangValue(fromLanguage))
        }, 200)
      }
    },
    copyLanguage (fromLanguage, index, languages, metadataLanguageValue) {
      if (index < languages.length) {
        var language = this.object.languageValue[index]
        if (language.key !== fromLanguage.key && language.value.trim() === '') {
          transport.methods.setLanguageValue(this.object, this.htmlValue, language.key)
          transport.methods.setLanguageValue(this.getRequestObjectById(this.requestObjectForAdd, this.definition.id + 'metadata'), metadataLanguageValue, language.key)
        }
        this.copyLanguage(fromLanguage, ++index, languages, metadataLanguageValue)
      } else {
        var self = this
        setTimeout(function () {
          self.translating = false
          self.$emit('validateMandatory', moment().valueOf(), self.object)
        }, 200)
      }
    },
    isForCopy () {
      return transport.methods.isForCopy(this.definition)
    },
    refreshDefinitionContent () {
      this.$emit('refreshDefinitionContent')
    },
    getEditorId () {
      return 'd1_' + this.tinyId + moment().valueOf()
    },
    taskLink (obj) {
      this.$emit('taskLink', obj)
    },
    getMetadataValue () {
      var result
      var name = this.definition.id + 'metadata'
      var obj = this.getRequestObjectById(this.requestObjectForAdd, name)

      if (obj) {
        result = transport.methods.getLanguageValue(obj, this.languageSelected.key)
        if (result === '') {
          result = {}
        } else {
          result = JSON.parse(result)
        }
      } else {
        result = {}
      }

      return result
    },
    isEmpty (obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          return false
        }
      }
      return JSON.stringify(obj) === JSON.stringify({})
    },
    isHtmlUploaded () {
      return (this.htmlValue && this.htmlValue !== '' && (!this.editorContent || this.isEmpty(this.editorContent)))
    },
    getTemplateValue (name) {
      var result = ''

      if (this.content) {
        var namePreffix = 'apptmpl_template_'
        var definition = transport.methods.getRequestDefinitionById(namePreffix + name, this.content.requestDefinition)

        if (definition) {
          result = transport.methods.getObjectTextValue(
            null,
            definition,
            this.getRequestObjectById(null, namePreffix + name),
            null
          )
        }
      }

      return result
    },
    getTypeValue () {
      var result = ''
      if (this.definition.id.indexOf('email') > -1) {
        result = 'newsletter'
      } else if (this.definition.id.indexOf('landing') > -1) {
        result = 'webpage'
      } else {
        result = 'webpage'
      }
      return result
    },
    getLang (key) {
      return language(this.language, key)
    },
    getRequestObjectById (reqObj, id) {
      if (reqObj) {
        return transport.methods.getRequestObjectById(id, [reqObj])
      } else if (this.content) {
        return transport.methods.getRequestObjectById(id, this.content.requestObject)
      } else {
        return []
      }
    },
    getTemplateDomain (name) {
      var result = []
      if (this.content) {
        var namePreffix = 'apptmpl_template_'
        var definition = transport.methods.getRequestDefinitionById(namePreffix + name, this.content.requestDefinition)
        if (definition) {
          result = definition.validation.domain
        }
      }
      return result
    },
    definitionLoaded () {
      this.loadingEditor = false
    },
    editorChange (template, html) {
    },
    editorSave (template, html) {
      var contentObj = this.getRequestObjectById(this.requestObjectForAdd, this.definition.id + 'metadata')
      var contentHtmlObj = this.object

      // not equals languages = language change
      if (this.previousLanguageKey !== this.languageSelected.key) {
        this.savingLanguageTemplate = true
      }

      // save template before language change
      if (this.savingLanguageTemplate) {
        if (!this.previousLanguageKey && this.languageSelected) {
          this.previousLanguageKey = this.languageSelected.key
        }
        transport.methods.setLanguageValue(contentObj, template, this.previousLanguageKey)
        transport.methods.setLanguageValue(contentHtmlObj, html, this.previousLanguageKey)

        var self = this
        setTimeout(function () {
          self.savingLanguageTemplate = false
          if (this.languageSelected) {
            this.previousLanguageKey = this.languageSelected.key
          }
        }, 200)

      // save template before copy template to other languages
      } else if (this.copyingTemplateLanguage) {
        transport.methods.setLanguageValue(contentObj, template, this.languageSelected.key)
        transport.methods.setLanguageValue(contentHtmlObj, html, this.languageSelected.key)

        this.copyTemplate()

      // call save template service
      } else {
        transport.methods.setLanguageValue(contentObj, template, this.languageSelected.key)
        transport.methods.setLanguageValue(contentHtmlObj, html, this.languageSelected.key)
      }

      this.editing = false
      this.editorContentBckp = null
    },
    previewToEdit () {
      this.editing = true
      this.loadingEditor = true
      this.editorContentBckp = JSON.parse(JSON.stringify(this.editorContent))
    },
    saveEditor () {
      this.saveTemplate = {
        ts: moment().valueOf()
      }
    },
    cancelEditor () {
      this.editorContent = null
      this.$nextTick(() => {
        this.editorContent = JSON.parse(JSON.stringify(this.editorContentBckp))
        this.editorContentBckp = null
      })
      this.editing = false
    },
    deleteHtml () {
      // Dialog
      let message = this.getLang('confirmDeleteHtml')
      let options = {
        okText: this.getLang('delete'),
        cancelText: this.getLang('cancel'),
        customClass: 'sherpaDialog'
      }
      this.$dialog.confirm(message, options)
        .then(() => {
          var contentObj = this.getRequestObjectById(this.requestObjectForAdd, this.definition.id + 'metadata')
          var contentHtmlObj = this.object

          transport.methods.setLanguageValue(contentObj, '', this.languageSelected.key)
          transport.methods.setLanguageValue(contentHtmlObj, '', this.languageSelected.key)

          this.setIframeHtml('preview')
        })
        .catch(() => {
        })
    }
  },
  mounted () {
    this.setHtmlValue(this.languageSelected)
  },
  watch: {
    mandatoryValidation (value) {
      // 2. if mandatory validation past...
      if (value && (value.validateKey === null || value.validateKey.trim() === '')) {
        // ... launch html format validation
        this.validateHtmlFormat()
      }
    },
    languageSelected (languageSelected) {
      if (this.languageSelected) {
        this.previousLanguageKey = this.languageSelected.key
      }
      if (this.isMultiLanguage()) {
        this.setLanguageHtmlValue(languageSelected)
      }
      if (languageSelected) {
        this.editorContent = null
        this.$nextTick(() => {
          this.setHtmlValue(this.languageSelected)
        })
      }
    },
    object: {
      handler (object) {
        this.editorContent = null
        this.$nextTick(() => {
          this.setHtmlValue(this.languageSelected)
        })
      },
      deep: true
    },
    requestObjectForAddModified: {
      handler (requestObjectForAddModified) {
        this.refreshObjectHtmlValue(this.requestObjectForAdd)
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
.definition-wrapper.html {
  .preview {
    margin-top: 10px;
    padding: 5px;
    opacity: 0.80;
    transition: all 0.2s ease-in;
    background-color: #fff;
    border-radius: 4px;
    border:2px dashed #ff7643;
    min-height: 150px;

  }
  .languageHtml {
    float: left;
  }
  .tiny-rest {
    position: absolute;
    z-index: 10;
    left: 50px;
    top: -27px;

    .languageSelector {
      float: right;

      &.languageSelectorHtml {
        .language {
          float: right;
          min-width: 106px;
          min-height: 51px;
        }

        .multiselect {
          width: 106px;
          display: inline-block;

          .multiselect__content-wrapper {
            position: relative;
          }

          .arrow {
            left: 80px;
          }
        }
      }
    }
  }

  input.w3-input {
    border-radius: 3px;
    background-color: #ffffff;
    border: solid 1px #e8e8e8;
    height: 40px;

    &:focus {
      border: solid 1px #b8b8b8;
    }
  }
  .mce-panel {
    border-width: 0 !important;
    border: 0 !important;
  }

  .htmlReadOnly {
    border: 0;
    width: 100%;
    overflow: hidden;
    min-height: 600px;
    max-height: 600px;
  }

  .overImage {
    position: absolute;
    background-color: rgba(0,0,0,0.2);
    top: 12px;
    bottom: 0;
    left: 0;
    right: 27px;

    .text {
      position: absolute;
      top: 43%;
      margin-top: -15px;
      text-align: center;
      left: 0;
      right: 0;
      transition: margin-top 0.2s ease-in-out;

      span {
        padding: 6px 22px 7px;
        color: #fff;
        text-transform: uppercase;
        background-color: #ff7643;
        font-size: 13px;
        border-radius: 3px;
        font-family: Capriola;
        cursor: pointer;
      }
    }
  }

  .editing {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0,0,0,0.5);
    z-index: 10000;
    overflow: hidden;

    .editor-buttons {
      text-align: center;

      button {
        padding: 0 20px;
        height: 35px;
        border-radius: 8px;
        -webkit-transition: all 0.2s ease-in;
        transition: all 0.2s ease-in;
        margin-right: 20px;
        margin-top: 10px;
        min-width: 250px;
        cursor: pointer;
        border-color: transparent;

        &.save {
          background-color: #00bb00;
        }

        &.cancel {
          background-color: #df0000;
        }

        span {
          font-family: Capriola;
          font-size: 16px;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: normal;
          letter-spacing: normal;
          text-align: center;
          color: #ffffff;
          font-weight: 400;
        }
      }
    }
  }

  .gallery-fade-enter-active {
    transition: all 0.2s ease-in-out;
  }
  .gallery-fade-enter-to {
    opacity: 1;
  }
  .gallery-fade-enter {
    opacity: 0;

    .text {
      margin-top: -35px !important;
    }
  }

  .tiny-rest {
    &.remove {
      left: 190px;
      top: -25px;

      i {
        font-size: 25px;
        cursor: pointer;

        &:before {
          color: #5dbecb;
          transition: all .2s ease-in;
        }

        &:hover {
          &:before {
            color: #4599a4;
          }
        }
      }

      .loading {
        margin-top: 5px;
      }
    }
  }
}
.repeatableGroupReadOnly {
  .definition-wrapper.html {
    .overImage {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/vue-definition/src/components/item/html.vue